export function formatStr(str, ...args) {
  let i = 0;
  return str.replace(/\{\}/g, () => args[i++]);
}
